// // import React, { useState } from "react";
// // import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// // import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
// // import { ReactComponent as DeleteIcon } from "../../../../assets/svgs/delete.svg";
// // import { rolesSample } from "../../../../utils/schema/rolesSample";
// // import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
// // import { useNavigate } from "react-router-dom";
// // import { Tables } from "../../../../components/Elements/Tables/Tables";
// // import CreateRoles from "../Users/DailogBoxes/CreateRoles";
// // import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
// // import SortData from "../../../../components/Elements/SortData.js/SortData";
// // import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// // import { THEME_COLORS } from "../../../../color";

// // const RolesPage = () => {
// //   const navigate = useNavigate();
// //   const [openCreateDailog, setOpenCreateDailog] = useState(false);
// //   const [searchTerm, setSearchTerm] = useState("");

// //   const tableData = rolesSample.map((item) => {
// //     const { serial, role, description } = item.tableData[0];
// //     return {
// //       key: item.key,
// //       serial,
// //       role,
// //       description,
// //       action: (
// //         <div className="flex gap-4 items-center">
// //           <EditIcon
// //             style={{ marginRight: 10, cursor: "pointer", color: "#06513D" }}
// //           />
// //           <DeleteIcon style={{ cursor: "pointer", color: "#06513D" }} />
// //         </div>
// //       ),
// //     };
// //   });

// //   const [roles, setRoles] = useState(tableData);
// //   const [sortBy, setSortBy] = useState(null);
// //   const [sortOrder, setSortOrder] = useState(null);
// //   const [filteredData, setFilteredData] = useState(tableData);
// //   const headers = [
// //     { label: "Sr. No.", key: "serial" },
// //     { label: "Role", key: "role" },
// //     { label: "Description", key: "description" },
// //     { label: "Action", key: "action" },
// //   ];
// //   const handleSearch = (value) => {
// //     setSearchTerm(value);

// //     const filtered = tableData.filter(
// //       (item) =>
// //         item.role.toLowerCase().includes(value.toLowerCase()) ||
// //         item.description.toLowerCase().includes(value.toLowerCase()),
// //     );

// //     setFilteredData(filtered);
// //   };

// //   const handleSort = (key, order) => {
// //     const sortedData = SortData({ data: filteredData, key, order });
// //     setFilteredData(sortedData);
// //     setSortBy(key);
// //     setSortOrder(order);
// //   };

// //   return (
// //     <div style={{ backgroundColor: "#fff" }} className="h-full px-5 pb-5 ">
// //       <div>
// //         <div className="flex justify-end text-xs font-light p-3">
// //           <p>Home</p>
// //           <span>/</span> <p>User Management</p>
// //           <span>/</span>
// //           <TextStyles style={{ color: "#06513D" }}>
// //             Roles and Permissions
// //           </TextStyles>
// //         </div>
// //         <div className="flex items-center mb-6 gap-2 text-xl text-[#06513D] font-bold">
// //           <Back onClick={() => navigate(-1)} className="cursor-pointer" />
// //           <div style={{ color: THEME_COLORS.green }}>Roles and Permission</div>
// //         </div>
// //         <div
// //           style={{
// //             border: "1px solid #ebedf3",
// //             borderRadius: "10px",
// //             paddingTop: "20px",
// //           }}
// //         >
// //           <div className="flex justify-between px-3 mb-3">
// //             <div className="flex gap-4 pl-9">
// //               <div className="px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-base font-light">
// //                 TOTAL ROLES
// //               </div>

// //               <SearchBar width="300px" onSearch={handleSearch} />
// //             </div>
// //             <div className="flex gap-4">
// //               <CustomButton
// //                 buttonType="button"
// //                 variant="ok"
// //                 buttonText=" + Add New"
// //                 onClick={() => setOpenCreateDailog(true)}
// //                 className="text-base font-normal h-[50px] w-[160px]"
// //               />
// //             </div>
// //           </div>

// //           <Tables
// //             data={filteredData}
// //             headers={headers}
// //             pageSize={7}
// //             sortBy={sortBy}
// //             sortOrder={sortOrder}
// //             onSort={handleSort}
// //           />
// //         </div>
// //         {openCreateDailog && (
// //           <CreateRoles
// //             onOpen={openCreateDailog}
// //             onClose={() => setOpenCreateDailog(false)}
// //           />
// //         )}
// //       </div>
// //     </div>
// //   );
// // };

// // export default RolesPage;

// import React, { useState } from "react";
// import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
// import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
// import { ReactComponent as DeleteIcon } from "../../../../assets/svgs/delete.svg";
// import { rolesSample } from "../../../../utils/schema/rolesSample";
// import { ReactComponent as Back } from "../../../../assets/svgs/back-button.svg";
// import { useNavigate } from "react-router-dom";
// import { Tables } from "../../../../components/Elements/Tables/Tables";
// import CreateRoles from "../Users/DailogBoxes/CreateRoles";
// import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
// import SortData from "../../../../components/Elements/SortData.js/SortData";
// import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
// import { THEME_COLORS } from "../../../../color";
// import { IoArrowBackCircleOutline } from "react-icons/io5";

// const RolesPage = () => {
//   const navigate = useNavigate();
//   const [openCreateDailog, setOpenCreateDailog] = useState(false);
//   const [searchTerm, setSearchTerm] = useState("");

//   const tableData = rolesSample.map((item) => {
//     const { serial, role, description } = item.tableData[0];
//     return {
//       key: item.key,
//       serial,
//       role,
//       description,
//       action: (
//         <div className="flex gap-4 items-center">
//           <EditIcon
//             style={{ marginRight: 10, cursor: "pointer", color: "#06513D" }}
//           />
//           <DeleteIcon style={{ cursor: "pointer", color: "#06513D" }} />
//         </div>
//       ),
//     };
//   });

//   const [roles, setRoles] = useState(tableData);
//   const [sortBy, setSortBy] = useState(null);
//   const [sortOrder, setSortOrder] = useState(null);
//   const [filteredData, setFilteredData] = useState(tableData);
//   const headers = [
//     { label: "Sr. No.", key: "serial" },
//     { label: "Role", key: "role" },
//     { label: "Description", key: "description" },
//     { label: "Action", key: "action" },
//   ];
//   const handleSearch = (value) => {
//     setSearchTerm(value);

//     const filtered = tableData.filter(
//       (item) =>
//         item.role.toLowerCase().includes(value.toLowerCase()) ||
//         item.description.toLowerCase().includes(value.toLowerCase()),
//     );

//     setFilteredData(filtered);
//   };

//   const handleSort = (key, order) => {
//     const sortedData = SortData({ data: filteredData, key, order });
//     setFilteredData(sortedData);
//     setSortBy(key);
//     setSortOrder(order);
//   };

//   return (
//     <div className=" md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
//       <div>
//         <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
//           <p>Home</p>
//           <span>/</span>
//           <p>User Management</p>
//           <span>/</span>
//           <TextStyles style={{ color: "#06513D" }}>
//             {" "}
//             Roles and Permissions
//           </TextStyles>
//         </div>

//         <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
//           <IoArrowBackCircleOutline
//             onClick={() => navigate(-1)}
//             className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition"
//           />
//           <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
//             Roles and Permission
//           </div>
//         </div>

//         <div
//           style={{
//             border: "1px solid #ebedf3",
//             borderRadius: "10px",
//             paddingTop: "20px",
//             backgroundColor: "#fff",
//           }}
//         >
//           <div className="flex flex-col sm:flex-row justify-between px-3 mb-3 gap-4">
//             <div className="flex flex-col sm:flex-row gap-4 pl-0 sm:pl-9">
//               <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
//                 TOTAL ROLES
//               </div>

//               <SearchBar width="100%" onSearch={handleSearch} />
//             </div>
//             <div className="flex gap-4">
//               <CustomButton
//                 buttonType="button"
//                 variant="ok"
//                 buttonText=" + Add New"
//                 onClick={() => setOpenCreateDailog(true)}
//                 className="text-sm sm:text-base font-normal h-[50px] w-full sm:w-[160px]"
//               />
//             </div>
//           </div>

//           <div className="overflow-x-auto">
//             <Tables
//               data={filteredData}
//               headers={headers}
//               pageSize={7}
//               sortBy={sortBy}
//               sortOrder={sortOrder}
//               onSort={handleSort}
//             />
//           </div>
//         </div>
//         {openCreateDailog && (
//           <CreateRoles
//             onOpen={openCreateDailog}
//             onClose={() => setOpenCreateDailog(false)}
//           />
//         )}
//       </div>
//     </div>
//   );
// };

// export default RolesPage;
import React, { useState, useEffect } from "react";
import TextStyles from "../../../../components/Elements/TextStyles/TextStyles";
import { ReactComponent as EditIcon } from "../../../../assets/svgs/edit-green.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/svgs/delete.svg";
import { rolesSample } from "../../../../utils/schema/rolesSample";
import { useNavigate } from "react-router-dom";
import { Tables } from "../../../../components/Elements/Tables/Tables";
import CreateRoles from "../Roles/DIalogBoxes/CreateRoles";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";
import SortData from "../../../../components/Elements/SortData.js/SortData";
import { SearchBar } from "../../../../components/Elements/Search/SearchBar";
import { IoArrowBackCircleOutline } from "react-icons/io5";

const MobileCard = ({ item }) => (
  <div
    key={item.key}
    className="bg-white rounded-xl shadow-md border border-gray-200 p-2 mb-4"
    style={{
      background: "linear-gradient(135deg, #ffffff 0%, #f8fffe 100%)",
    }}
  >
    <div className="flex justify-between mb-2">
      <span className="font-semibold text-gray-600">#</span>
      <span className="font-medium text-gray-800">{item.serial}</span>
    </div>
    <div className="flex justify-between mb-2">
      <span className="font-semibold text-gray-600">Role</span>
      <span className="font-medium text-gray-800">{item.role}</span>
    </div>

    <div className="flex justify-between mb-2">
      <span className="font-semibold text-gray-600">Description</span>
      <span className="font-medium text-gray-800">{item.description}</span>
    </div>

    {/* Updated Description row */}
    {/* <div className="flex mb-2">
      <span className="font-semibold text-gray-600 min-w-[90px]">Description</span>
      <span className="font-medium text-gray-800 whitespace-normal break-words flex-1">
        {item.description}
      </span>
    </div> */}

    <div className="flex justify-between items-center">
      <span className="font-semibold text-gray-600">Action</span>
      <div className="flex gap-3">{item.action}</div>
    </div>
  </div>
);

const RolesPages = () => {
  const navigate = useNavigate();
  const [openCreateDailog, setOpenCreateDailog] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const tableData = rolesSample
    .filter((item) => {
      const roleName = item.tableData[0].role;
      return (
        roleName !== "Sub Admin" &&
        roleName !== "Sub - Admin" &&
        roleName !== "Management View"
      );
    })
    .map((item) => {
      const { serial, role, description } = item.tableData[0];
      return {
        key: item.key,
        serial,
        role,
        description,
        action: (
          <div className="flex gap-4 items-center">
            <EditIcon
              style={{ marginRight: 10, cursor: "pointer", color: "#06513D" }}
            />
            <DeleteIcon style={{ cursor: "pointer", color: "#06513D" }} />
          </div>
        ),
      };
    });

  const [sortBy, setSortBy] = useState(null);
  const [sortOrder, setSortOrder] = useState(null);
  const [filteredData, setFilteredData] = useState(tableData);

  const headers = [
    { label: "Sr. No.", key: "serial" },
    { label: "Role", key: "role" },
    { label: "Description", key: "description" },
    { label: "Action", key: "action" },
  ];

  const handleSearch = (value) => {
    setSearchTerm(value);

    const filtered = tableData.filter(
      (item) =>
        item.role.toLowerCase().includes(value.toLowerCase()) ||
        item.description.toLowerCase().includes(value.toLowerCase()),
    );

    setFilteredData(filtered);
  };

  const handleSort = (key, order) => {
    const sortedData = SortData({ data: filteredData, key, order });
    setFilteredData(sortedData);
    setSortBy(key);
    setSortOrder(order);
  };

  return (
    <div className="md:p-6 lg:p-0 bg-[#F5F5F5] mb-20 sm:mb-6 md:mb-6">
      <div>
        {/* Breadcrumb */}
        <div className="flex flex-wrap justify-end text-xs h-5 font-light gap-1 sm:gap-2">
          <p>Home</p>
          <span>/</span>
          <p>User Management</p>
          <span>/</span>
          <TextStyles style={{ color: "#06513D" }}>
            {" "}
            Roles and Permissions
          </TextStyles>
        </div>

        {/* Title & Back Icon */}
        <div className="flex items-center gap-2 sm:mb-1.5 text-lg sm:text-xl font-bold flex-wrap">
          <IoArrowBackCircleOutline
            onClick={() => navigate(-1)}
            className="w-8 sm:w-10 h-8 sm:h-10 text-[#06513D] hover:text-white hover:bg-[#06513D] rounded-full transition cursor-pointer"
          />
          <div className="text-[#06513D] font-[Calibri] text-[18px] sm:text-[20px] leading-none tracking-tight">
            Roles and Permission
          </div>
        </div>

        {/* Main Card */}
        <div
          style={{
            border: "1px solid #ebedf3",
            borderRadius: "10px",
            paddingTop: "20px",
            backgroundColor: "#fff",
          }}
        >
          <div className="flex flex-col sm:flex-row justify-between px-3 mb-3 gap-4">
            <div className="flex flex-col sm:flex-row gap-4 pl-0 sm:pl-9">
              <div className="px-6 sm:px-8 h-[42px] flex items-center justify-center border border-[#06513D] bg-[#E6EEEC] rounded-md text-[#06513D] text-sm sm:text-base font-light whitespace-nowrap">
                TOTAL ROLES
              </div>

              <SearchBar width="100%" onSearch={handleSearch} />
            </div>
            <div className="flex gap-4">
              <CustomButton
                buttonType="button"
                variant="ok"
                buttonText=" + Add New"
                onClick={() => setOpenCreateDailog(true)}
                className="text-sm sm:text-base font-normal h-[50px] w-full sm:w-[160px]"
              />
            </div>
          </div>

          {/* Table on desktop, cards on mobile */}
          <div className="overflow-x-auto px-2">
            {!isMobile ? (
              <Tables
                data={filteredData}
                headers={headers}
                pageSize={7}
                sortBy={sortBy}
                sortOrder={sortOrder}
                onSort={handleSort}
              />
            ) : filteredData.length === 0 ? (
              <p className="text-center text-gray-500 py-8">No roles found.</p>
            ) : (
              filteredData.map((item) => (
                <MobileCard key={item.key} item={item} />
              ))
            )}
          </div>
        </div>

        {openCreateDailog && (
          <CreateRoles
            onOpen={openCreateDailog}
            onClose={() => setOpenCreateDailog(false)}
          />
        )}
      </div>
    </div>
  );
};

export default RolesPages;
